let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bvmfY")).then(() => parcelRequire('4eVVU'));